(function () {
    'use strict';

    angular
        .module('skillsApp')
        .directive('marksList', marksList);

    function marksList() {
        return {
            templateUrl: '/app/directives/marks-list.tpl.html',
            scope: {
                activity: '=',
                allowAdd: '=',
                allowDelete: '=',
                group: '=',
                userQuality: '='
            },
            controller: MarksListController,
            controllerAs: 'vm',
            bindToController: true
        };
    }

    function MarksListController($scope, logger, modalDialogService, dataService) {
        var vm = this;
        
        var approvedDates = vm.activity.marks.map(function (item) {
            if (item.approvedDate) {
                return new Date(item.approvedDate);
            }
        });

        if (approvedDates.length > 0) {
            approvedDates.sort(function (val1, val2) {
                return val2 - val1;
            });
            vm.lastApprovedDate = approvedDates[0];
        }

        vm.addMark = addMark;
        vm.deleteMark = deleteMark;
        
        function addMark() {

            var activity = {
                userQualityId: vm.userQuality.id,
                groupId: vm.group.groupId,
                activityId: vm.activity.id
            };

            modalDialogService.openMarkDialog(activity);
        }

        function deleteMark(mark) {
            modalDialogService.confirmYesNo('delete_mark', 'are_you_sure_you_want_to_delete_this_mark?', () => {
                dataService
                    .deleteMark(vm.userQuality.id, mark.id)
                    .then(result => {
                        logger.success('successfully_deleted');
                    });
            });
        }
    }

})();